<app-header></app-header>

<div class="wrapper">
    <app-estimate-box [isLoader]="isLoader" [showForward]="false" [submitBtnLabel]="'Continue'"
        (submitBtnClick)="continue()" (backClick)="back()"></app-estimate-box>
    <div class="section_wrapper" style="margin-top: 20px;">


        <!-- stepper component -->
        <div class="dashBoard review_section_wrap">
            <app-stepper currentIndex="3" class="stepper"></app-stepper>
            <div class="review w_100">
                <div class="review_wrap">
                    <!-- <h3 class="font_40_a32">Review</h3> -->
                    <div class="order_wrapper">
                        <p class="font_24_a32_600">Order Summary</p>
                        <div class="order_item item1">
                            <p class="order_text">
                                <span class="font_16">ID Number</span>
                                <span class="font_16">{{selectedPlan.packageid}}</span>
                            </p>
                            <p class="order_text">
                                <span class="font_16">Item</span>
                                <span class="font_16 order_infor_text">{{selectedPlan.name}}</span>
                            </p>
                            <p class="order_text">
                                <span class="font_16">
                                    Price
                                </span>
                                <span class="font_16 order_infor_text"> ${{selectedPlan.price | number}}</span>
                            </p>
                            <p class="order_text">
                                <span class="font_16">Quantity</span>
                                <span class="font_16 order_infor_text">01</span>
                            </p>

                        </div>
                        <div class="order_item item2">
                            <p class="plan order_subtitle">Plan</p>
                            <p class="selected_plan order_text">
                                <span class="plan_name order_infor_text">{{selectedPlan.name}}</span>
                                <span class="plan_price ">
                                    <sup class="doller">$</sup>{{selectedPlan.price |
                                    number}}
                                </span>
                            </p>
                        </div>
                        <div class="order_item item3" *ngIf="selectedMls">
                            <p class="order_subtitle">MLS Service</p>
                            <div *ngFor="let selected of selectedMls; let i = index" style="margin: 16px 0;">

                                <p class="order_text">
                                    <span class="font_18 order_infor_text">{{selected.name}} </span>
                                    <span class="plan_price"><sup class="doller">$</sup>{{selected.price}}</span>
                                </p>
                                <p class="mls_price" *ngIf="selected.lockbox && selected.lockbox.isLockIncluded">
                                    Lockbox Service Added
                                    <!-- : ${{selected.lockbox.price}}* -->
                                </p>
                            </div>
                        </div>
                        <div class="order_item item4" *ngIf="selectedAddons && selectedAddons.length > 0">
                            <p class="order_subtitle">Addons</p>
                            <div *ngFor="let selectedAddon of selectedAddons; let i = index" style="margin: 16px 0;">
                                <p class="order_text">
                                    <span class="font_18 order_infor_text">{{selectedAddon.name}}</span>
                                    <span class="plan_price"><sup>$</sup>{{selectedAddon.price | number}}</span>
                                </p>
                            </div>
                        </div>
                        <div class="order_item item5">
                            <p class="total_text">
                                <span class="total">TOTAL</span> <span class="font_40_a32">
                                    <sup class="doller">$</sup>{{totalAmount |
                                    number}}</span>
                            </p>

                        </div>
                        <!-- <div class="order_item item6"> -->

                        <!-- <form class="form_section" [formGroup]="reviewForm">
                                <div *ngFor="let item of checkBoxList">

                                    <mat-checkbox color="'#042A32'" class="example-margin" formControlName="checkbox"
                                        (change)="selectedValues(item.name)">
                                        <p class="font_16_a32">{{item.name}}</p>
                                    </mat-checkbox> -->

                        <!-- <app-checkbox class="example-margin" (checkedChange)="selectedValues(item.name)"
                                        formControlName="checkbox" [label]="item.name" [labelFontSize]="'16px'">
                                    </app-checkbox> -->

                        <!-- </div> -->

                        <!-- <div class="owner_ship">
                                    <mat-form-field appearance="fill" class="w_100">
                                        <mat-label>Ownership type</mat-label>
                                        <mat-select formControlName="drop">
                                            <mat-option *ngFor="let type of ownType" [value]="type.value">
                                                {{type.viewValue}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-error class="error-message"
                                        *ngIf="reviewForm.get('drop').hasError('required') && isSubmitted">Please
                                        select ownership type

                                    </mat-error>
                                </div>
                                <div class="shipping">

                                    <p class="font_16_a32_700">SHIPPING ADDRESS</p>
                                    <mat-checkbox color="'#042A32'" class="example-margin" (change)="addressAutopopulate()"
                                    formControlName="checks">
                                    <p class="font_16_a32">Use same as that of Property</p>
                                </mat-checkbox> -->

                        <!-- <app-checkbox class="example-margin" (checkedChange)="addressAutopopulate()"
                                        formControlName="checks" [label]="'Use same as that of Property'"
                                        [labelFontSize]="'16px'">
                                    </app-checkbox> -->

                        <!-- <p class="shipping_content">This is where we will ship any physical items included
                                        in your package or you
                                        order separately (e.g. For Sale Sign, Lockbox, etc) and send any correspondence
                                        regarding your listing.</p>
                                    <div class="shipping_form_section">
                                        <div>
                                            <mat-form-field class="w_100">
                                                <mat-label>STREET ADDRESS</mat-label>
                                                <input matInput formControlName="streetVal">
                                            </mat-form-field>
                                            <mat-error class="error-message"
                                                *ngIf="reviewForm.get('streetVal').hasError('required') && isSubmitted">Please
                                                enter
                                                the street address
                                            </mat-error>

                                        </div>
                                        <div>
                                            <mat-form-field class="w_100">
                                                <mat-label>CITY</mat-label>
                                                <input matInput formControlName="cityVal">
                                            </mat-form-field>
                                            <mat-error class="error-message"
                                                *ngIf="reviewForm.get('cityVal').hasError('required') && isSubmitted">Please
                                                enter city name

                                            </mat-error>
                                        </div>
                                        <div class="state_zip">
                                            <div>
                                                <mat-form-field appearance="fill" class="w_100">
                                                    <mat-label>STATE</mat-label>
                                                    <mat-select name="StateOrProvince" formControlName="stateVal">
                                                        <mat-option *ngFor="let StateOrProvince of stateList"
                                                            [value]="StateOrProvince.value">
                                                            {{StateOrProvince.viewValue}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                                <mat-error class="error-message"
                                                    *ngIf="reviewForm.get('stateVal').hasError('required') && isSubmitted">Please
                                                    enter
                                                    the state
                                                </mat-error>
                                            </div>
                                            <div>
                                                <mat-form-field class="w_100">
                                                    <mat-label>ZIP CODE</mat-label>
                                                    <input matInput placeholder="" name="zipCode" maxlength="5"
                                                        formControlName="zipCodesVal">
                                                </mat-form-field>
                                                <mat-error class="error-message"
                                                    *ngIf="reviewForm.get('zipCodesVal').hasError('required') && isSubmitted">Please
                                                    enter
                                                    the zipcode
                                                </mat-error>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form> -->

                        <!-- </div> -->

                    </div>
                    <!-- <div class="submit_buttons">
                      
                        <div class="buttons">
                            <button class="back_button" (click)="back()">Back</button>
                            <app-green-button-v2 label="Continue" *ngIf="!isLoader" (click)=continue() [width]="'166px'"
                                [height]="'60px'">
                                <img class="after" src="../../../assets/icons/arrow_white.svg" alt="arrow_white"
                                    style="margin-left: 10px;">
                            </app-green-button-v2>
                            
                            <app-loader *ngIf="isLoader" class="loader_wrap"></app-loader>
                        </div>
                    </div> -->
                    <br>
                    <app-green-button-v2 *ngIf="isScreenWidthLarge && !isLoader" [buttonType]="'submit'"
                        (click)="continue()" class="create_button" label="Continue" [width]="'200px'"
                        [height]="'47px'">
                    </app-green-button-v2>

                    <div class="mobile_submitButtons">
                        <button class="arrowBtn leftArrow" (click)="back()">
                            <img src="../../../assets/icons/arrow_left_grey.svg" alt="arrow_left">
                        </button>
                        <app-green-button-v2 class="SumbitBtnRes" (click)="continue()" label="Submit"
                            [buttonType]="'submit'" [width]="'136px'" [height]="'50px'">
                        </app-green-button-v2>
                        <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>
                        <!-- <button (click)="continue()" class="arrowBtn rightArrow">
                            <img src="../../../assets/icons/arrow_right_grey.svg" alt="arrow-right">
                        </button> -->
                    </div>
                </div>
            </div>
        </div>

    </div>